/**
 * Product tabs (sections/product-tabs.liquid).
 * Desktop: tabs. Mobile: acordeão, cada item abre/fecha de forma independente.
 * Eventos delegados no document para continuar funcionando quando a section é
 * re-renderizada (editor de temas, theme dev, Section Rendering API).
 */
function activate(root, index) {
  root.querySelectorAll('.product-tabs__tab').forEach((tab, i) => {
    const selected = i === index;
    tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    tab.tabIndex = selected ? 0 : -1;
  });
  root.querySelectorAll('.product-tabs__panel').forEach((panel, i) => {
    const active = i === index;
    panel.classList.toggle('is-active', active);
    panel.hidden = !active;
  });
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-product-tabs] .product-tabs__accordion');
  if (trigger) {
    const open = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(open));
    trigger.closest('.product-tabs__item')?.classList.toggle('is-open', open);
    return;
  }

  const tab = e.target.closest('[data-product-tabs] .product-tabs__tab');
  if (tab) {
    const index = parseInt(tab.dataset.tabIndex, 10);
    if (!Number.isNaN(index)) activate(tab.closest('[data-product-tabs]'), index);
  }
});

document.addEventListener('keydown', (e) => {
  const current = e.target.closest?.('[data-product-tabs] .product-tabs__tab');
  if (!current) return;

  const root = current.closest('[data-product-tabs]');
  const tabs = Array.from(root.querySelectorAll('.product-tabs__tab'));
  const index = tabs.indexOf(current);
  let next = index;
  if (e.key === 'ArrowRight') next = Math.min(tabs.length - 1, index + 1);
  else if (e.key === 'ArrowLeft') next = Math.max(0, index - 1);
  else if (e.key === 'Home') next = 0;
  else if (e.key === 'End') next = tabs.length - 1;
  else return;

  e.preventDefault();
  activate(root, next);
  tabs[next]?.focus();
});
